var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('kst-output',{attrs:{"field":"DeliveryAddress","data":_vm.data,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"field":"DeliveryDate","data":_vm.data,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }